import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=c497fe8a&scoped=true&lang=html&"
import script from "./ResultPage.vue?vue&type=script&lang=js&"
export * from "./ResultPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=c497fe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c497fe8a",
  null
  
)

export default component.exports